export default __webpack_public_path__ + "c10.png";